// extracted by mini-css-extract-plugin
export var filterIncDec = "_ef-0";
export var leftBorder = "_ef-1";
export var rightBorder = "_ef-2";
export var stringInput = "_ef-3";